<h1 class="save-line-head">Download</h1>
<h4 i18n='@@intro-download'>In quest'area è possibile scaricare Plugin e integrazioni SDK in-App.</h4>

<div class="menu-row">
  <a routerLink="plugin" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="plugin" class="start-icon"></mat-icon>
        <span class="label">Plugin</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>

  <a routerLink="sdk" class="menu-link">
    <mat-card class="menu-card">
      <div class="menu-content">
        <mat-icon svgIcon="box" class="start-icon"></mat-icon>
        <span class="label">SDK per In-App</span>
        <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
      </div>
    </mat-card>
  </a>
</div>
